export const API_CONFIG = {
  RUNTIME_INVOKER_URL: process.env.REACT_APP_RUNTIME_INVOKER_URL || 'https://6hvrdenyomumgqs3c5retvfnyy0rtdns.lambda-url.us-east-1.on.aws/',
  RESUME_API: process.env.REACT_APP_RESUME_API || 'https://nvm573yo08.execute-api.us-east-1.amazonaws.com',
  RESUME_API_URL: process.env.REACT_APP_RESUME_API || 'https://nvm573yo08.execute-api.us-east-1.amazonaws.com', // Alias for consistency
  INVENTORY_READ_API: process.env.REACT_APP_INVENTORY_READ_RUNTIME_INVOKER_URL,
  INVENTORY_WRITE_API: process.env.REACT_APP_INVENTORY_WRITE_RUNTIME_INVOKER_URL,
  FEEDBACK_AGENT_URL: process.env.REACT_APP_FEEDBACK_AGENT_URL,
  CHAT_HISTORY_API: process.env.REACT_APP_CHAT_HISTORY_API,
  // Legacy support - fallback to read API
  INVENTORY_API: process.env.REACT_APP_INVENTORY_READ_RUNTIME_INVOKER_URL || process.env.REACT_APP_INVENTORY_API,
  STOCK_UPDATE_API: process.env.REACT_APP_INVENTORY_WRITE_RUNTIME_INVOKER_URL,
};

// Debug logging
console.log('🔧 API_CONFIG loaded:');
console.log('  RESUME_API:', API_CONFIG.RESUME_API);
console.log('  process.env.REACT_APP_RESUME_API:', process.env.REACT_APP_RESUME_API);
console.log('  Expected: https://nvm573yo08.execute-api.us-east-1.amazonaws.com');
